import { z } from 'zod';

export const productSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255),
    description: z.string().max(1000).optional().or(z.literal('')).transform(v => v === '' ? undefined : v),
    status: z.string().min(1, 'Status is required').default('active'),
    capabilities: z.array(z.string()).default([]),
    effective_from: z.string().optional().or(z.literal('')).transform(v => v === '' ? undefined : v),
    parent_dealer_id: z.string().uuid().nullable().optional(),
    product_type_id: z
        .string({ required_error: 'Product Type is required', invalid_type_error: 'Product Type is required' })
        .uuid('Product Type is required'),
});

export type ProductFormInput = z.input<typeof productSchema>;
export type ProductFormOutput = z.output<typeof productSchema>;
